import { formatDomainInput, parseDomain } from '@wix/domains-serverless-interface';
import { DomainSearchError } from '../types';
const defaultConfigs = {
  connectOrBindResult: {
    status: 'fulfilled',
    value: {
      canConnectOrBind: false
    }
  },
  purchaseResult: {
    status: 'fulfilled',
    value: {
      canPurchase: false
    }
  },
  transferResult: {
    status: 'fulfilled',
    value: {
      canTransferIn: false
    }
  },
  canAssignDomainResult: {
    status: 'fulfilled',
    value: {
      canAssignDomain: false
    }
  }
};

/**
 * Check conditional error logic - throw error only if dependencies didn't fail
 */
export function shouldThrowConditionalError(dependencies, configs) {
  const dependencyKeys = Object.keys(dependencies);
  // Check if any dependency action failed
  const anyDependencyFailed = dependencyKeys.some(dep => {
    // Only check dependencies that were attempted (have capability)
    const depConfig = configs[dep];
    if (!depConfig || !depConfig.capability) {
      return false;
    }
    return hasActionError(depConfig.promiseResult);
  });
  return !anyDependencyFailed;
}
export function hasActionError(result) {
  var _result$value, _result$value2;
  return result.status === 'rejected' || result.status === 'fulfilled' && Boolean((_result$value = result.value) == null ? void 0 : _result$value.error) && !isDomainSearchError((_result$value2 = result.value) == null ? void 0 : _result$value2.error);
}
export function getErrorMessage(result) {
  var _result$value3;
  if (result.status === 'rejected') {
    var _result$reason;
    return ((_result$reason = result.reason) == null ? void 0 : _result$reason.message) || 'Unknown error';
  }
  if (result.status === 'fulfilled' && (_result$value3 = result.value) != null && _result$value3.error) {
    return result.value.error;
  }
  return 'Unknown error';
}
export function getError(result) {
  var _result$value4;
  if (result.status === 'rejected') {
    return result.reason instanceof Error ? result.reason : new Error('Unknown error');
  }
  if (result.status === 'fulfilled' && (_result$value4 = result.value) != null && _result$value4.error) {
    return result.value.error instanceof Error ? result.value.error : new Error('Unknown error');
  }
  return new Error('Unknown error');
}
export const overrideCapabilityConfigs = overrides => {
  return {
    ...defaultConfigs,
    ...(overrides ?? {})
  };
};
const DOMAIN_LABEL_CHARS = /^[\p{L}\p{N}](?:[\p{L}\p{N}.-]*[\p{L}\p{N}])?$/u;
export const toCorrectedDomain = query => {
  const spacelessQuery = (query == null ? void 0 : query.trim().replace(/\s+/g, '')) ?? '';
  if (!DOMAIN_LABEL_CHARS.test(spacelessQuery)) {
    return undefined;
  }
  const _parseDomain = parseDomain(spacelessQuery),
    error = _parseDomain.error,
    isValidTld = _parseDomain.isValidTld;
  if (error || !isValidTld) {
    return undefined;
  }
  return formatDomainInput(spacelessQuery);
};
export const isOfEnum = function () {
  for (var _len = arguments.length, enumerations = new Array(_len), _key = 0; _key < _len; _key++) {
    enumerations[_key] = arguments[_key];
  }
  return value => value && enumerations.some(enumeration => Object.values(enumeration).includes(value));
};
export const isDomainSearchError = isOfEnum(DomainSearchError);
//# sourceMappingURL=utils.js.map